"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectableStep = exports.standardStep = exports.standardStepperInner = exports.standardStepper = exports.useStepLabelStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStepLabelStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        labelContainer: {
            top: -65,
            position: 'relative',
        },
    });
});
exports.standardStepper = {
    width: '100%',
    textAlign: 'center',
    paddingBottom: '20px',
};
exports.standardStepperInner = {
    width: '50%',
    textAlign: 'center',
    margin: 'auto',
};
exports.standardStep = {
    textTransform: 'uppercase',
};
exports.selectableStep = __assign(__assign({}, exports.standardStep), { cursor: 'pointer' });
//# sourceMappingURL=StepperStyles.js.map